import axios from "../../axios";

export const getHeaderUserInfo = async (userId) => {
    const res = await axios.get(`users/user/${userId}/info`);
    return res.data;
};

export const getHeaderUserData = async () => {
    const res = await axios.get('userspagesdata/header_user_info');
    return res.data;
};